import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=062e9d43"
import script from "./CheckboxInput.ts?vue&type=script&lang=ts&external"
export * from "./CheckboxInput.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports